import { render, staticRenderFns } from "./ProjectAssignmentsKanbanView.vue?vue&type=template&id=d5ebebca&scoped=true"
import script from "./ProjectAssignmentsKanbanView.vue?vue&type=script&lang=js"
export * from "./ProjectAssignmentsKanbanView.vue?vue&type=script&lang=js"
import style0 from "./ProjectAssignmentsKanbanView.vue?vue&type=style&index=0&id=d5ebebca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5ebebca",
  null
  
)

export default component.exports